export function normalizeShopUrl(value: string): string {
  if (!value) {
    return '';
  }

  let normalized = value.trim();

  if (/^https?:\/\//i.test(normalized)) {
    const parsed = new URL(normalized);
    normalized = parsed.pathname || '';
  }

  normalized = normalized
    .toLowerCase()
    .replace(/\\/g, '/')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9/-]+/g, '')
    .replace(/-+/g, '-')
    .replace(/\/+/g, '/')
    .replace(/\/-/g, '/')
    .replace(/-\//g, '/');

  normalized = normalized
    .split('/')
    .map((segment) => segment.replace(/^-+|-+$/g, ''))
    .filter(Boolean)
    .join('/');

  return normalized ? `/${normalized}` : '';
}

export function getShopUrlSegments(value: string): string[] {
  return value.split('/').filter(Boolean);
}
